import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import {
	UpdateMinimumWithdrawSettingRequest,
	UpdateMinimumWithdrawSettingResponse,
} from '../../../type'
import { updateMinimumWithdrawSetting } from '../../services'

interface UseMutationUpdateMinimumWithdrawProps {
	payload: UpdateMinimumWithdrawSettingRequest
}

export default function useMutationUpdateMinimumWithdraw(
	props?: UseBaseMutationOptions<
		UpdateMinimumWithdrawSettingResponse,
		UseMutationUpdateMinimumWithdrawProps
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.UpdateMinimumWithdrawSetting],
		mutationFn: ({ payload }) => {
			return updateMinimumWithdrawSetting(payload)
		},
		...props,
	})
}
